import React, { useEffect, useState } from 'react';
import TextField, { Props as TextFieldProps } from '../TextField';

export type NumberInputProps = Omit<TextFieldProps, 'onChange'> & {
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, value: number | null) => void;
};

const NumberInput = (props: NumberInputProps) => {
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    if (Number(value) !== props.value) {
      setValue(typeof props.value === 'number' ? props.value.toString() : '');
    }
  }, [props.value]);

  return (
    <TextField
      {...props}
      value={value}
      onChange={(event) => {
        const inputValue = event.target.value;
        const cleanedValue = inputValue
          .replace(/[^0-9.-]/g, '')
          .replace(/(?!^)-/g, '')
          .replace(/(\..*?)\./g, '$1');
        const isValidNumber = !isNaN(parseFloat(cleanedValue));
        const isEmptyValue = cleanedValue === '';
        const isPartialNegativeValue = cleanedValue.length === 1 && cleanedValue === '-';
        const isPartialDecimalValue = cleanedValue.length && cleanedValue.endsWith('.') && cleanedValue.match(/\./g)?.length === 1;

        if (isValidNumber || isEmptyValue || isPartialNegativeValue || isPartialDecimalValue) {
          setValue(cleanedValue);
        }

        if (props.onChange && (isEmptyValue || isValidNumber)) {
          const newValue = !isEmptyValue ? Number(cleanedValue) : null;
          props.onChange(event, newValue);
        }
      }} />
  );
};

export default NumberInput;